import React from "react";
import styled from "styled-components";
import {
  FaFacebook,
  FaGithub,
  FaLinkedin,
  FaMicrosoft,
  FaInstagram,
  FaGoogle,
  FaReddit,
  FaYoutube,
  FaTwitch
} from "react-icons/fa";
import { IconContext } from "react-icons";

const HoverButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: orange;
  position: fixed;
  top: 12vh;
  right: 0;
  max-width: 50px;
  max-height: 20px;
  border-top: 3px solid black;
  border-left: 3px solid black;
  border-bottom: 3px solid black;
  transition: max-height 0.15s ease-out, max-width 0.15s ease-out;
  overflow: hidden;
  padding: 15px;
  border-top-left-radius: 45px;
  border-bottom-left-radius: 45px;
  z-index: 20;
  &:hover {
    background-color: purple;
    max-width: 200px;
    max-height: 600px;
    transition: max-height 0.25s ease-in, max-width 0.25s ease-in;
    p {
      display: none;
    }
    div {
      visibility: visible;
      opacity: 1;
      transition: opacity 1s ease-in;
    }
  }

  p {
    margin: 0 auto;
    padding: 0;
    color: purple;
    font-weight: 600;
    font-family: "Lucida Console", monospace;
    visibility: visible;
    font-size: calc(8px + 1.2vmin);
  }

  div {
    visibility: collapse;
    opacity: 0;
    transition: opacity 0.1s ease-out;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    color: white;

    ul {
      text-align: right;
      li {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 5px;
        a {
          color: lightblue;
          text-decoration: none;
          transition-duration: 0.2s;
          white-space: nowrap;
          &:hover {
            color: orange;
            transform: scale(1.2);
          }
        }
      }
    }
  }
`;

const linkList = [
  {
    url: "https://www.gmail.com",
    text: "Gmail",
    icon: <FaGoogle size={30} color={"#4285F4"} />
  },
  {
    url: "https://www.hotmail.com",
    text: "Hotmail",
    icon: <FaMicrosoft size={30} color={"#00A4EF"} />
  },
  {
    url: "https://www.facebook.com",
    text: "Facebook",
    icon: <FaFacebook size={30} color={"#4267B2"} />
  },
  {
    url: "https://www.instagram.com",
    text: "Instagram",
    icon: <FaInstagram size={30} color={"#E1306C"} />
  },
  {
    url: "https://www.reddit.com",
    text: "Reddit",
    icon: <FaReddit size={30} color={"#FF4500"} />
  },
  {
    url: "https://www.youtube.com",
    text: "Youtube",
    icon: <FaYoutube size={30} color={"#FF0000"} />
  },
  {
    url: "https://www.twitch.com",
    text: "Twitch",
    icon: <FaTwitch size={30} color={"#6441A4"} />
  },
  {
    url: "https://www.github.com",
    text: "Github",
    icon: <FaGithub size={30} color={"black"} />
  },
  {
    url: "https://www.linkedin.com",
    text: "Linkedin",
    icon: <FaLinkedin size={30} color={"#2867B2"} />
  }
];

const UsefulLinks = () => {
  return (
    <HoverButton>
      <p>Links</p>
      <div>
        <IconContext.Provider value={{ style: { verticalAlign: "middle" } }}>
          <ul>
            {linkList.map((value, index) => {
              return (
                <li key={index}>
                  <a href={value.url}>
                    {value.text} {value.icon}
                  </a>
                </li>
              );
            })}
          </ul>
        </IconContext.Provider>
      </div>
    </HoverButton>
  );
};

export default UsefulLinks;
